/* Virtros cart drawer: upsell carousel + add, ships-by date, auto-open switch.
   Custom elements, so they re-initialise every time Dawn re-renders the drawer. */
(function () {
  /* Ships-by date: today + N days (optionally skipping weekends), in the visitor's locale */
  if (!customElements.get('vt-ship-date')) {
    customElements.define('vt-ship-date', class extends HTMLElement {
      connectedCallback() {
        try {
          const days = parseInt(this.dataset.days || '0', 10);
          const skip = this.dataset.skipWeekend === 'true';
          const d = new Date();
          let added = 0;
          while (added < days) {
            d.setDate(d.getDate() + 1);
            if (skip && (d.getDay() === 0 || d.getDay() === 6)) continue;
            added++;
          }
          if (skip) while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
          const opts = { day: 'numeric', month: 'long' };
          if (this.dataset.year === 'true') opts.year = 'numeric';
          let txt;
          try { txt = new Intl.DateTimeFormat(this.dataset.locale || undefined, opts).format(d); }
          catch (e) { txt = new Intl.DateTimeFormat(undefined, opts).format(d); }
          const tpl = this.querySelector('template');
          const out = this.querySelector('[data-text]');
          if (tpl && out) out.innerHTML = tpl.innerHTML.replace('[date]', txt);
        } catch (e) { /* keep server-rendered fallback date */ }
      }
    });
  }

  /* Carousel arrows */
  if (!customElements.get('vt-cart-upsell')) {
    customElements.define('vt-cart-upsell', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        if (!track) return;
        const step = () => {
          const card = track.querySelector('.vt-up__card');
          return card ? card.getBoundingClientRect().width + 8 : track.clientWidth;
        };
        const dir = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.querySelector('[data-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step() * dir, behavior: 'smooth' }));
        this.querySelector('[data-next]')?.addEventListener('click', () => track.scrollBy({ left: step() * dir, behavior: 'smooth' }));
      }
    });
  }

  /* Upsell card: variant pickers + add to cart (re-renders drawer through Dawn's cart-drawer) */
  if (!customElements.get('vt-upsell-card')) {
    customElements.define('vt-upsell-card', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.vt-up__add');
        const json = this.querySelector('[data-variants]');
        this.variants = json ? JSON.parse(json.textContent) : null;
        this.querySelectorAll('select[data-option]').forEach((s) => s.addEventListener('change', () => this.onChange()));
        this.btn?.addEventListener('click', () => this.add());
      }
      onChange() {
        if (!this.variants) return;
        const chosen = [...this.querySelectorAll('select[data-option]')].map((s) => s.value);
        const v = this.variants.find((x) => x.options.every((o, i) => o === chosen[i]));
        const price = this.querySelector('[data-price]');
        const compare = this.querySelector('[data-compare]');
        if (!v) { this.btn.disabled = true; return; }
        this.btn.dataset.variant = v.id;
        this.btn.disabled = !v.available;
        if (price) price.innerHTML = v.price;
        if (compare) compare.innerHTML = v.compare || '';
      }
      async add() {
        const id = this.btn.dataset.variant;
        if (!id || this.btn.disabled) return;
        const drawer = document.querySelector('cart-drawer');
        this.btn.classList.add('is-loading');
        this.btn.disabled = true;
        // Same Shopify standard event Dawn's product form fires, so Add to Cart reaches Shopify analytics / pixels.
        const SE = window.StandardEvents || {};
        let deferred = null;
        try {
          if (SE.CartLinesUpdateEvent) {
            deferred = SE.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(new SE.CartLinesUpdateEvent({
              action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise,
            }));
          }
        } catch (e) { deferred = null; }
        try {
          const res = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(id), quantity: 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
          if (deferred) {
            fetch(`${window.routes.cart_url}.json`).then((r) => r.json()).then((cart) => {
              if (!cart || !cart.currency) return deferred.reject(new Error('Missing currency'));
              deferred.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
            }).catch((e) => deferred.reject(e));
          }
          if (drawer) drawer.classList.remove('is-empty');
          if (drawer && drawer.renderContents && data.sections) {
            drawer.renderContents({ ...data, id: Number(id) });
          } else {
            window.location.href = window.routes.cart_url;
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id, cartData: data });
          }
        } catch (e) {
          if (deferred) deferred.reject(e);
          if (SE.CartErrorEvent) { try { this.dispatchEvent(new SE.CartErrorEvent({ error: e.message, code: 'INVALID' })); } catch (x) {} }
          const err = document.getElementById('CartDrawer-CartErrors');
          if (err) err.textContent = (window.cartStrings && window.cartStrings.error) || 'Something went wrong';
          this.btn.disabled = false;
        } finally {
          this.btn.classList.remove('is-loading');
        }
      }
    });
  }
})();
